import { useMemo } from 'react';

import { type AssistanceServiceInputParam } from '@atlassian/conversation-assistant-service/services/assistance-service/main';

import { useRovoSettingsConfig } from '../rovo-settings-config';

export const useAssistanceServiceParams = ({
	touchpointSource,
}: Pick<
	AssistanceServiceInputParam['assistanceServiceParams'],
	'touchpointSource'
>): AssistanceServiceInputParam['assistanceServiceParams'] => {
	const { product, siteId, experienceId, assistanceServiceConfig } = useRovoSettingsConfig();

	return useMemo(
		() => ({
			product,
			experienceId,
			touchpointSource,
			siteId,
			headers: assistanceServiceConfig?.headers,
		}),
		[product, experienceId, touchpointSource, siteId, assistanceServiceConfig?.headers],
	);
};
